import React from 'react';
const AllipseGroup = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#7D8085';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("g", { opacity: "0.4" },
            React.createElement("circle", { cx: "5", cy: "2", r: "1.5", fill: stroke }),
            React.createElement("circle", { cx: "5", cy: "8", r: "1.5", fill: stroke }),
            React.createElement("circle", { cx: "5", cy: "14", r: "1.5", fill: stroke }),
            React.createElement("circle", { cx: "11", cy: "2", r: "1.5", fill: stroke }),
            React.createElement("circle", { cx: "11", cy: "8", r: "1.5", fill: stroke }),
            React.createElement("circle", { cx: "11", cy: "14", r: "1.5", fill: stroke }))));
};
export default AllipseGroup;
